<template>
    <LayoutSub className="business_unit">
        <SubSection classList="pb-0">
            <h1>
                <strong class="c-red">전국 630여개 대리점 채널</strong>과 협력하여 <br /><strong class="c-red">고객중심의 서비스</strong>를 제공하는
                채널영업본부
            </h1>
            <p>
                채널영업본부는 전국적으로 분포한 수백만 개의 가맹점과 접점을 이루는 대리점 채널들과의 긴밀한 협력관계를 유지함으로써<br class="pc-only" />
                지역 영업망을 강화하여 고객 중심의 마케팅 및 서비스를 제공하고 있습니다. <br /><br />
                또한 우수 영업조직의 신규 영입으로 영업경쟁력을 강화하고, 업계 최다 정유 보너스VAN 사업자로써의 지위를 유지하고 있으며 <br class="pc-only" />
                또한 이지포스솔루션의 지속적인 고도화 개발과 적극적인 마케팅 및 교육 등을 통하여 회사의 매출신장과 시장점유율 확대에 적극 기여하고
                있습니다. <br />
                <br />
                채널영업본부의 주요 업무로는 채널영업과 더불어 영업계획, 정책, 전략들을 기획, 수립하며 실적 분석 관리 및 피드백과 지속적인 백오피스
                고도화 개발 등을 통해 <br class="pc-only" />
                전국 630여 개 대리점 지원, 관리 및 신규 대리점 영입 업무 등을 수행합니다. <br />
                <br />
                한국정보통신(주) 수익창출의 핵심인 채널영업본부에서는 도전정신과 창의적 사고, 열정을 겸비한 인재를 기다리고 있습니다.
            </p>
            <img src="@/assets/channel_sales_image01.png" alt="">
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>